
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { chatApi } from '@/lib/api/chat';
import { toast } from 'sonner';

export const INBOX_KEY = 'chat-inbox';
export const CONVERSATION_KEY = 'chat-conversation';

export function useInbox() {
  return useQuery({
    queryKey: [INBOX_KEY],
    queryFn: () => chatApi.listInbox(),
    refetchInterval: 30_000,
    staleTime: 10_000,
  });
}

export function useConversation(id: string | null) {
  return useQuery({
    queryKey: [CONVERSATION_KEY, id],
    queryFn: () => chatApi.getConversation(id!),
    enabled: !!id,
    staleTime: 5_000,
  });
}

export function useTakeOver(convId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => chatApi.takeOver(convId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: [CONVERSATION_KEY, convId] });
      void qc.invalidateQueries({ queryKey: [INBOX_KEY] });
    },
    onError: () => toast.error('Failed to take over conversation'),
  });
}

export function useSendAgentMessage(convId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (content: string) => chatApi.sendAgentMessage(convId, content),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: [CONVERSATION_KEY, convId] });
    },
    onError: () => toast.error('Failed to send message'),
  });
}

export function useResolveConversation(convId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: () => chatApi.resolve(convId),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: [CONVERSATION_KEY, convId] });
      void qc.invalidateQueries({ queryKey: [INBOX_KEY] });
      toast.success('Conversation resolved');
    },
    onError: () => toast.error('Failed to resolve conversation'),
  });
}
